const toggleScrolling = (enable) => {
  if ($('.popup-enabled').length > 0) {
    if (enable) {
      $('body').removeClass('popup-active');
    } else {
      $('body').addClass('popup-active');
    }
  }
};

const updateSubmitButtonState = () => {
  let allQuestionsAnswered = true;

  const radioGroups = $('input[type="radio"]').map(function () {
    return $(this).attr('name');
  }).get().filter((value, index, self) => self.indexOf(value) === index);

  radioGroups.forEach((name) => {
    if (!$(`input[type="radio"][name="${name}"]:checked`).length) {
      allQuestionsAnswered = false;
    }
  });

  $('.submit-btn').prop('disabled', !allQuestionsAnswered);
};

const questionnairePopup = () => {
  const $questionnairePopup = $('#questionnaire-popup');
  const $popups = $('.popup');
  const $resultPopups = $popups.not('#questionnaire-popup');
  const $overlay = $('.questionnaire-popup__overlay');

  $('.submit-btn').prop('disabled', true);

  $('input[type="radio"]').on('change', updateSubmitButtonState);

  $('.submit-btn').on('click', (e) => {
    e.preventDefault();
    let yesCount = 0;

    $('input[type="radio"]:checked').each(function () {
      yesCount += $(this).val() === 'yes' ? 1 : 0;
    });

    $questionnairePopup.fadeOut();
    $resultPopups.fadeOut();
    yesCount <= 2 ? $('#first-result').fadeIn() : $('#second-result').fadeIn();
    $overlay.fadeIn();
    toggleScrolling(false);
  });

  $questionnairePopup.fadeIn();
  $overlay.fadeIn();
  toggleScrolling(false);

  $popups.on('click', '.close-popup', () => {
    $popups.hide();
    $overlay.fadeOut();
    toggleScrolling(true);
    $('input[type="radio"]').prop('checked', false);
    updateSubmitButtonState();
  });
};

export default questionnairePopup;
